import request from "root/js/request";

export const getBloggerCard = async ({
  account_name_hash,
  source,
  ordering,
  limit,
  offset,
  ...rest
}) => {
  const response = await request({
    url: `/parsers/social/blogger_card/`,
    method: "get",
    params: {
      account_name_hash,
      source,
      ordering,
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
